<template>
  <div>
    <el-table :data="list" :header-cell-style="{ backgroundColor: '#eaeaea' }">
      <el-table-column type="index" />
      <el-table-column align="center" label="名称" prop="name" />
      <el-table-column align="center" label="文号" prop="code" />
      <el-table-column align="center" label="详述" prop="detail" :show-overflow-tooltip="true" />
      <el-table-column align="center" label="状态" prop="status" />
      <el-table-column align="center" label="操作">
        <template v-slot="scope">
          <el-button type="text" @click="handleEnter(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getInfo, getRevenueBaseInfoList } from '@/api/enterprise'

export default {
  data () {
    return {
      list: [
        {
          name: '中小企业数字化水平评测指标',
          code: '2024年版',
          detail: '《中小企业数字化水平评测指标（2024年版）》延续2022年版整体架构，从数字化基础、经营、管理、成效四个维度综合评估中小企业数字化发展水平，并对评测方式进行了调整优化，其中，数字化基础、管理和成效三个维度采用评分的方式确定等级，数字化经营部分用场景等级判定的方式确定等级。',
          status: '进行中'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['staff'])
  },
  methods: {
    handleEnter (row) {
      Promise.all([
        getInfo({ userId: this.staff.id }).then(res => {
          return res.data || {}
        }),
        getRevenueBaseInfoList(this.staff.id).then(res => {
          return res.data || []
        })
      ]).then(([info, revenue]) => {
        const isFull = !revenue.some(v => isInchoateRevenue(v))
        if (info.contactsPhone && info.enterpriseScale && info.segmentedIndustries && (!info.isDigitize || info.headPhone) && isFull) {
          this.$router.push('/proposal')
        } else {
          this.$confirm('请先完善企业信息，再进行问巻调查。', '提示', {
            confirmButtonText: '确定',
            showClose: false,
            showCancelButton: false,
            type: 'warning'
          }).then(() => {
            this.$router.push('/info')
          }).catch(() => {
            this.$router.push('/info')
          })
        }
      })
    }
  }
}

function isInchoateRevenue (v) {
  return (v.propertyCount ?? null) === null || (v.taxes ?? null) === null || (v.personCount ?? null) === null || (v.digitCount ?? null) === null || (v.personRevenue ?? null) === null || (v.profit ?? null) === null || (v.digitInput ?? null) === null
}
</script>
